/**
 * Created by emma on 17/1/20.
 */
var stats = {
    init: function () {
        window.onerror = function (msg, url, line, col, error) {
            _hmt.push(['_trackEvent', 'window', 'error', msg, url + ',' + line + ',' + col]);
        };
    },
    trackEvent: function (category, action = 'click', label = '-', value = '-') {
        _hmt.push(['_trackEvent', category, action, label, value]);
    }
};

export default stats;


// WEBPACK FOOTER //
// ./components/stats.js